import { useQuery } from "react-query";
import { AppConstant, KeyConstant } from "@/const";
import { UserService } from "@/services";
import { PaginationType } from "@/types/common";

const useExternalUserList = (props: Partial<PaginationType>) => {
  const { page, size } = props;

  const { data, isLoading, isError } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getUsers, page, size],
    queryFn: () =>
      UserService.getExternalUsers({
        page: page || 1,
        size: size || AppConstant.DEFAULT_SIZE_PAGE,
      }),
    keepPreviousData: true,
    retry: 0,
  });

  const { data: users, ...pagination } = data || {};

  return {
    users: users || [],
    pagination: (pagination as PaginationType) || {},
    isLoading,
    isError,
  };
};

export default useExternalUserList;
